const bgBtn = require(`../img/primary-button-fill.svg`)

const style_operations= {
    img_disabled: {
        opacity: '0.5',
        width: '100%'
    },
    btn_disabled: {
        color: 'currentColor',
        cursor: 'not-allowed',
        opacity: '0.5',
        textDecoration: 'none',
        backgroundColor:'#616365',
        padding: '15px',
        fontSize: '13px',
        fontWeight: 'bold',
        paddingLeft: '25px',
        paddingRight: '25px',
        minWidth: '212px',
        '&:hover': {
            background:'#616365',
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow:'none',
        }
    },
    img_valid :{
        width: '50%',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    opacityCard:{
        opacity:'0.30',
        backgroundColor:'#0099ff',
        cursor:'not-allowed',
    },

    cornerRibbon:{
        left: '0px',
        width: '100%',
        zIndex: 20,
        opacity: 0.8,
        position: 'absolute',
        background: '#0099ff',
        height: '100%',
        borderRadius:'5px',
    },
    RibbonGrid: {
        position: 'absolute',
        left: '0px',
        width: '100%',
        height: '100%',
    },
    cornerRibbonText:{
        color: '#fff',
        textAlign: 'center',
        lineHeight: '50px',
        letterSpacing: '1px',
        textTransform:'uppercase',
        fontSize:'30px',
        fontWeight:'900',
        width:'100%',
    },

    textCenter :{
        margin:'auto',
    },
    cardCategory:{
        textAlign: 'center',
        fontSize: '14px!important',
        marginBottom: '14px!important',
        color:'#000!important',

    },
    btnPartRG:{
        backgroundColor:'#f2c61d',
        padding: '15px',
        fontSize: '13px',
        fontWeight: 'bold',
        paddingLeft: '25px',
        paddingRight: '25px',
        minWidth: '212px',

        '&:hover': {
            background:'#f2c61d',
            color: '#ffffff',
        }
    },
    btnPart:{
        borderRadius: '.4em',
        backgroundColor: '#319ebb',
        padding: '1.2em 2em',
        width: '210px',
        minHeight: '3rem',
        fontWeight: '700',
        display: 'inline-block',
        overflow: 'hidden',
        fontSize: '12px',

        '&::after': {
            position: 'absolute',
            left: '0',
            content: `''`,
            backgroundImage: 'url(' + bgBtn + ')',
            backgroundSize: '60% 250%',
            width: '300%',
            height: '300%',
            backgroundPosition: '18% -17%',
            backgroundRepeatY: 'no-repeat',
            bottom: '0',
            transition: 'transform 1s',
            backfaceVisibility: 'hidden',
            transform: 'translate(-66%,34%)',
            zIndex: '-1',
        },


        '&:hover': {
            background:'#ea8905',
            color: '#ffffff',

            '&::after': {
                transform: 'translate(0,0)',
                transition: 'transform .75s',
                backfaceVisibility: 'hidden',
            }
        },

        '&:focus': {
            background:'#ea8905',
            color: '#ffffff',

            '&::after': {
                transform: 'translate(0,0)',
                transition: 'transform .75s',
                backfaceVisibility: 'hidden',
            }
        },
    },
    btnPartSC:{
        backgroundColor:'#00965f',
        padding: '15px',
        fontSize: '13px',
        fontWeight: 'bold',
        paddingLeft: '25px',
        paddingRight: '25px',
        minWidth: '212px',
        '&:hover': {
            background:'#00965f',
            color: '#ffffff',
        }
    },
    titleOP: {
        color:'#00005a',
        textTransform: 'none',
        textAlign: 'center',
        marginTop: '0',
        fontWeight: '900',
        fontSize: '22px',
    },

    titleOperationRG:{
        textAlign: 'center',
        color: '#96452e;',
        fontSize: '25px',
    },
    titleOperationSC:{
        textAlign: 'center',
        color: '#00965f',
        fontSize: '25px',
    },
    PagesHeaderAppBar :{
        backgroundColor: '#ffffff!important',
    },
    spanColorRG :{
        color: '#96452e',
        fontWeight:'bold'
    },
    spanColorSC :{
        color: '#00965f',
        fontWeight:'bold'
    },
    conditionGeneralRG :{
        border:'1px solid #f2c61d',
        color: '#319ebb',
        fontSize: '13px',
        fontWeight: 'bold',
        backgroundColor:'#ffffff',
        maxWidth: '212px',
        wordWrap: 'break-word',
        textTransform: 'none',
        whiteSpace: 'normal',
        '&:hover': {
            background:'#319ebb',
            color: '#ffffff',
        }
    },
    conditionGeneralSC :{
        border:'1px solid #00965f',
        color: '#00965f',
        fontSize: '13px',
        fontWeight: 'bold',
        backgroundColor:'#ffffff',
        maxWidth: '212px',
        wordWrap: 'break-word',
        textTransform: 'none',
        whiteSpace: 'normal',
        '&:hover': {
            background:'#00965f',
            color: '#ffffff',
        }
    },
    conditionGeneralNone:{
        maxWidth: '212px',
        color: 'currentColor',
        cursor: 'not-allowed',
        opacity: '0.5',
        wordWrap: 'break-word',
        textTransform: 'none',
        whiteSpace: 'normal',
        textDecoration: 'none',
        backgroundColor:'#616365',
        padding: '15px',
        fontSize: '13px',
        fontWeight: 'bold',
        paddingLeft: '25px',
        paddingRight: '25px',
        minWidth: '212px',
        '&:hover': {
            background:'#616365',
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow:'none',
        }
    },
    conditionGeneral :{
        border:'1px solid #0093d0',
        color: '#0093d0',
        fontSize: '13px',
        fontWeight: 'bold',
        backgroundColor:'#ffffff',
        maxWidth: '212px',
        wordWrap: 'break-word',
        textTransform: 'none',
        whiteSpace: 'normal',
        '&:hover': {
            background:'#0093d0',
            color: '#ffffff',
        }
    },
    stats : {
        textAlign: 'center!important',
        display: 'block!important',
        color:'#000!important',
        fontSize:'14px!important',

        '& span': {
            color:'#f50082',
            fontFamily:'Roboto',
            fontWeight:'700',
        },
    },

    cardHead : {
        marginTop: '-40px',
    },
    customTableImage: {
        width:'100%',
    },
};

export default style_operations;



// WEBPACK FOOTER //
// ./src/assets/css/style_custom.jsx